import { render } from "./FilterSorting.vue?vue&type=template&id=24f279d4&ts=true"
import script from "./FilterSorting.vue?vue&type=script&lang=ts"
export * from "./FilterSorting.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__